<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <div class="app-container">
    <!-- Header Section with Logo, Dashboard, Profile, and Logout -->
    <Header />

    <!-- Sidebar and Main Content -->
    <main :class="mainContentClass">
      <div class="main-header">
        <h1 class="main-title">Listings</h1>
        <div class="header-actions">
          <button class="main-btn" @click="navigateToNewListing">
            <vue-feather type="plus" size="18" />
            <span>New Listing</span>
          </button>
        </div>
        <!-- add a button to create new flight -->
        <!-- <button class="main-btn" @click="navigateToNewFlight">
          <vue-feather type="plus" size="18" />
          <span>New Flight</span>
        </button> -->
      </div>

      <Divider />
      <br />

      <h2 class="header-title">My Listings</h2>

      <!-- Table -->
      <div class="table-container">
        <div v-if="isLoading" class="loading-state">
          <vue-feather type="loader" size="24" class="spin"></vue-feather>
          <span class="loading-text">Loading your listings...</span>
        </div>
        <div v-else-if="flights.length === 0" class="empty-state">
          <vue-feather type="calendar" size="48" style="color: #aaa" />
          <br />
          <p class="empty-message">You don't have any listings yet.</p>
        </div>
        <div v-else class="reservation-table desktop-table">
          <div class="table-header">
            <div class="th listing-column">LISTING</div>
            <div class="th views-column">VIEWS</div>
            <div class="th bookings-column">BOOKINGS</div>
            <div class="th status-column">STATUS</div>
            <div class="th privacy-column">PRIVACY</div>
            <div class="th actions-column">ACTIONS</div>
          </div>
          <div class="table-body">
            <div v-for="flight in flights" :key="flight.id" class="table-row">
              <!-- Listing Column -->
              <div
                class="td listing-column"
                @click="$router.push(`/listing?listingId=${flight.id}`)"
                style="cursor: pointer"
              >
                <div class="listing-info">
                  <img
                    :src="
                      flight.bannerUrl ||
                      require('@/assets/placeholder-image-listing.png')
                    "
                    class="listing-image"
                    alt="Listing"
                  />
                  <div class="listing-details">
                    <span class="listing-name">{{ flight.title }}</span>
                    <span class="listing-location">{{ flight.location }}</span>
                  </div>
                </div>
              </div>
              <!-- Views Column -->
              <div class="td views-column">
                <span class="counter">{{ flight.views || 0 }}</span>
              </div>
              <!-- Bookings Column -->
              <div class="td bookings-column">
                <span class="counter">{{ flight.bookingsCount || 0 }}</span>
              </div>
              <!-- Status Column -->
              <div class="td status-column">
                <div class="toggle-container">
                  <label class="toggle-switch">
                    <input
                      type="checkbox"
                      :checked="flight.isActive"
                      @change="toggleActive(flight)"
                    />
                    <span class="toggle-slider"></span>
                  </label>
                </div>
              </div>
              <!-- Privacy Column -->
              <div class="td privacy-column">
                <div class="toggle-container">
                  <label class="toggle-switch">
                    <input
                      type="checkbox"
                      :checked="flight.isPrivate"
                      @change="togglePrivate(flight)"
                    />
                    <span class="toggle-slider"></span>
                  </label>
                </div>
              </div>
              <!-- Actions Column -->
              <div class="td actions-column">
                <button
                  class="action-btn edit-btn"
                  @click="editListing(flight)"
                >
                  <vue-feather type="edit-2" size="16"></vue-feather>
                  Edit
                </button>
              </div>
            </div>
          </div>
        </div>

        <!-- Mobile Card Layout -->
        <div class="listing-cards mobile-cards">
          <div
            v-for="flight in flights"
            :key="flight.id"
            class="listing-card-mobile"
          >
            <div class="card-header-mobile">
              <div class="listing-info-mobile">
                <img
                  :src="
                    flight.bannerUrl ||
                    require('@/assets/placeholder-image-listing.png')
                  "
                  class="listing-image-mobile"
                  alt="Listing"
                />
                <div class="listing-details-mobile">
                  <span class="listing-name-mobile">{{ flight.title }}</span>
                  <span class="listing-location-mobile">{{
                    flight.location
                  }}</span>
                </div>
              </div>
              <div class="toggle-container-mobile">
                <div class="toggle-group-mobile">
                  <div class="toggle-item-mobile">
                    <span class="toggle-label-mobile">Status</span>
                    <label class="toggle-switch-mobile">
                      <input
                        type="checkbox"
                        :checked="flight.isActive"
                        @change="toggleActive(flight)"
                      />
                      <span class="toggle-slider-mobile"></span>
                    </label>
                  </div>
                  <div class="toggle-item-mobile">
                    <span class="toggle-label-mobile">Privacy</span>
                    <label class="toggle-switch-mobile">
                      <input
                        type="checkbox"
                        :checked="flight.isPrivate"
                        @change="togglePrivate(flight)"
                      />
                      <span class="toggle-slider-mobile"></span>
                    </label>
                  </div>
                </div>
              </div>
            </div>

            <div class="card-content-mobile">
              <div class="actions-mobile">
                <button
                  class="action-btn-mobile edit-btn-mobile"
                  @click="editListing(flight)"
                >
                  <vue-feather type="edit-2" size="16"></vue-feather>
                  Edit
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
    <!-- Footer -->
    <!-- <footer class="footer">
      <p>&copy; 2024 Skyhost. All rights reserved.</p>
    </footer> -->
  </div>
</template>

<script>
import {
  getFirestore,
  collection,
  onSnapshot,
  orderBy,
  query,
  doc,
  updateDoc,
} from "firebase/firestore";
import { isMobile } from "@/utils/helper";
import Header from "@/components/organisms/Header.vue";
import { auth } from "../plugins/firebase";
import Divider from "@/components/organisms/Divider.vue";

export default {
  data() {
    return {
      flights: [],
      isLoading: true,
    };
  },
  components: {
    Header,
    Divider,
  },
  methods: {
    navigateToNewListing() {
      this.$router.push("/list-an-event");
    },
    navigateToNewFlight() {
      this.$router.push("/new-flight");
    },
    fetchFlights() {
      this.isLoading = true;
      const userId = auth.currentUser.uid;
      console.log("userId", userId);
      const db = getFirestore();
      const flightsQuery = query(
        collection(db, "listings"),
        orderBy("createdAt", "desc")
      );

      this.unsubscribe = onSnapshot(flightsQuery, (snapshot) => {
        const flights = snapshot.docs
          .filter((doc) => doc.data().creatorUserId === userId)
          .map((doc) => {
            return {
              id: doc.id,
              isActive: doc.data().isActive || false,
              isPrivate: doc.data().isPrivate || false,
              views: doc.data().views || 0,
              bookingsCount: doc.data().bookingsCount || 0,
              ...doc.data(),
            };
          });

        this.flights = flights;
        this.isLoading = false;
      });
    },

    editListing(listing) {
      // Store the listing ID to edit in route params
      this.$router.push({
        name: "NewListing",
        query: {
          edit: true,
          listingId: listing.id,
        },
      });
    },

    formatMonth(date) {
      if (!date) return "";
      return date.toLocaleDateString("en-US", { month: "short" }).toUpperCase();
    },

    formatDay(date) {
      if (!date) return "";
      return date.getDate();
    },

    formatTime(date) {
      if (!date) return "";
      return date.toLocaleTimeString([], {
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
      });
    },

    async toggleActive(listing) {
      try {
        // Get the new state (opposite of current)
        const newActiveState = !listing.isActive;

        // Update the local state for immediate UI feedback
        listing.isActive = newActiveState;

        // Update in Firestore
        const db = getFirestore();
        const listingRef = doc(db, "listings", listing.id);

        await updateDoc(listingRef, {
          isActive: newActiveState,
          updatedAt: new Date(),
        });

        console.log(
          `Listing ${listing.id} is now ${
            newActiveState ? "active" : "inactive"
          }`
        );
      } catch (error) {
        // Revert the local state change if the update fails
        listing.isActive = !listing.isActive;
        console.error("Error toggling listing status:", error);
      }
    },

    async togglePrivate(listing) {
      try {
        // Get the new state (opposite of current)
        const newPrivateState = !listing.isPrivate;

        // Update the local state for immediate UI feedback
        listing.isPrivate = newPrivateState;

        // Update in Firestore
        const db = getFirestore();
        const listingRef = doc(db, "listings", listing.id);

        await updateDoc(listingRef, {
          isPrivate: newPrivateState,
          updatedAt: new Date(),
        });

        console.log(
          `Listing ${listing.id} is now ${
            newPrivateState ? "private" : "public"
          }`
        );
      } catch (error) {
        // Revert the local state change if the update fails
        listing.isPrivate = !listing.isPrivate;
        console.error("Error toggling listing privacy:", error);
      }
    },
  },
  computed: {
    activeListingsCount() {
      return this.flights.filter((flight) => flight.isActive).length;
    },
    totalViews() {
      return this.flights.reduce(
        (total, flight) => total + (flight.views || 0),
        0
      );
    },
    totalBookings() {
      return this.flights.reduce(
        (total, flight) => total + (flight.bookingsCount || 0),
        0
      );
    },
    mainContentClass() {
      return isMobile() ? "mobile-main-content" : "web-main-content";
    },
  },
  mounted() {
    this.fetchFlights();
  },
  beforeUnmount() {
    if (this.unsubscribe) {
      this.unsubscribe();
    }
  },
};
</script>

<style scoped>
/* Container and layout */
.app-container {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  background-color: #fff;
}

/* Main Content */
.mobile-main-content {
  margin-top: 20px;
  padding: 20px;
}

.web-main-content {
  padding: 8rem 10rem;
}

.main-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 2rem;
}

.main-title {
  font-size: 3rem;
  color: #000;
}

.header-actions {
  display: flex;
  gap: 1rem;
}

.main-btn {
  background-color: #000;
  color: white;
  border: none;
  border-radius: 12px;
  font-size: 0.9rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.75rem 1.25rem;
  height: 48px;
}

.main-btn:hover {
  opacity: 0.9;
}

.main-btn span {
  display: inline-block;
  line-height: 1;
}

/* Table Styles */
.table-container {
  margin-top: 2rem;
  background-color: white;
  border-radius: 16px;
  overflow: hidden;
}

.dashboard-stats {
  margin-bottom: 3rem;
}

.section-header {
  margin-bottom: 32px;
}

.section-description {
  color: #6b7280;
  font-size: 16px;
  line-height: 1.5;
  margin-top: 8px;
}

.header-title {
  font-size: 1.5rem;
  color: #000;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 1rem;
}

.stats-cards {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
  gap: 1.5rem;
}

.stat-card {
  background-color: #f9fafb;
  border-radius: 12px;
  padding: 1.5rem;
  position: relative;
  transition: all 0.3s ease;
}

.stat-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 10px 25px -10px rgba(0, 0, 0, 0.1);
}

.stat-number {
  font-size: 2.25rem;
  font-weight: 600;
  color: #111827;
  margin: 0 0 0.5rem 0;
}

.stat-label {
  font-size: 0.875rem;
  color: #6b7280;
  margin: 0;
}

.stat-icon {
  position: absolute;
  top: 1.5rem;
  right: 1.5rem;
  color: #9ca3af;
}

.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 300px;
  padding: 20px;
  background-color: #f9fafb;
}

.empty-message {
  margin-top: 1rem;
  color: #6b7280;
  font-size: 0.875rem;
}

.loading-state {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 200px;
  gap: 1rem;
  color: #6b7280;
}

.loading-text {
  font-size: 0.875rem;
  color: #6b7280;
}

.spin {
  animation: spin 1s linear infinite;
  margin-bottom: 0.5rem;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.reservation-table {
  width: 100%;
  border-radius: 12px;
  overflow: hidden;
}

.table-header {
  display: flex;
  background-color: #f9fafb;
  border-bottom: 1px solid #eee;
  padding: 1rem 1.5rem;
}

.table-row {
  display: flex;
  border-bottom: 1px solid #eee;
  align-items: center;
  padding: 0.75rem 1.5rem;
}

.table-row:hover {
  background-color: #f9fafb;
}

.th,
.td {
  font-size: 0.875rem;
  padding: 0.5rem;
}

.th {
  font-weight: 600;
  color: #4b5563;
  font-size: 0.813rem;
  text-transform: uppercase;
  letter-spacing: 0.025em;
}

/* Column width distribution */
.listing-column {
  width: 25%;
  flex: 0 0 25%;
}

.views-column,
.bookings-column {
  width: 8%;
  flex: 0 0 8%;
}

.status-column,
.privacy-column {
  width: 12%;
  flex: 0 0 12%;
}

.actions-column {
  width: 15%;
  flex: 0 0 15%;
  display: flex;
  gap: 10px;
}

/* Counter and metric styling */
.counter,
.price,
.capacity {
  font-size: 0.875rem;
  font-weight: 500;
  color: #374151;
}

/* Column specific styles */
.listing-info {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.listing-image {
  width: 64px;
  height: 48px;
  border-radius: 8px;
  object-fit: cover;
  border: 1px solid #e5e7eb;
}

.listing-details {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.listing-name {
  font-weight: 400;
  color: #111827;
  margin-bottom: 0.25rem;
  line-height: 1.25;
  font-size: 1rem;
  color: #222;
}

.listing-location {
  font-size: 0.75rem;
  color: #6b7280;
  line-height: 1.25;
}

/* Toggle switch styles */
.toggle-container {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  justify-content: flex-start;
  padding-left: 0.5rem;
}

.toggle-label {
  font-size: 0.875rem;
  font-weight: 500;
  min-width: 55px;
}

.toggle-switch {
  position: relative;
  display: inline-block;
  width: 40px;
  height: 24px;
}

.toggle-switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.toggle-slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #e5e7eb;
  transition: 0.4s;
  border-radius: 24px;
}

.toggle-slider:before {
  position: absolute;
  content: "";
  height: 18px;
  width: 18px;
  left: 3px;
  bottom: 3px;
  background-color: white;
  transition: 0.4s;
  border-radius: 50%;
}

input:checked + .toggle-slider {
  background-color: #2563eb;
}

input:checked + .toggle-slider:before {
  transform: translateX(16px);
}

/* Action button styles */
.action-btn {
  padding: 0.5rem 0.875rem;
  font-size: 0.813rem;
  border-radius: 6px;
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  cursor: pointer;
  transition: all 0.2s;
  min-width: 80px;
  justify-content: center;
}

.edit-btn {
  background-color: #f3f4f6;
  color: #111827;
  border: none;
}

.edit-btn:hover {
  background-color: #e5e7eb;
}

/* Make the table responsive */
@media (max-width: 1024px) {
  .listing-column {
    width: 25%;
    flex: 0 0 25%;
  }

  .views-column,
  .bookings-column {
    width: 10%;
    flex: 0 0 10%;
  }

  .status-column,
  .privacy-column {
    width: 15%;
    flex: 0 0 15%;
  }

  .actions-column {
    width: 20%;
    flex: 0 0 20%;
  }
}

@media (max-width: 768px) {
  .actions-column {
    width: 20%;
    flex: 0 0 20%;
  }

  .bookings-column {
    display: none;
  }

  .listing-column {
    width: 35%;
    flex: 0 0 35%;
  }

  .views-column {
    width: 12%;
    flex: 0 0 12%;
  }

  .status-column,
  .privacy-column {
    width: 16%;
    flex: 0 0 16%;
  }
}

/* Mobile Card Layout Styles */
@media (max-width: 768px) {
  /* Hide desktop table on mobile */
  .desktop-table {
    display: none;
  }

  /* Show mobile cards */
  .mobile-cards {
    display: block;
  }

  .listing-cards {
    display: flex;
    flex-direction: column;
    gap: 16px;
  }

  .listing-card-mobile {
    background: #fff;
    border: 1px solid #e5e7eb;
    border-radius: 12px;
    padding: 16px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  }

  .card-header-mobile {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin-bottom: 16px;
  }

  .listing-info-mobile {
    display: flex;
    align-items: center;
    gap: 12px;
    flex: 1;
    min-width: 0;
  }

  .listing-image-mobile {
    width: 64px;
    height: 48px;
    border-radius: 8px;
    object-fit: cover;
    border: 1px solid #e5e7eb;
    flex-shrink: 0;
  }

  .listing-details-mobile {
    display: flex;
    flex-direction: column;
    gap: 4px;
    flex: 1;
    min-width: 0;
  }

  .listing-name-mobile {
    font-size: 15px;
    font-weight: 500;
    color: #111827;
    line-height: 1.3;
  }

  .listing-location-mobile {
    font-size: 13px;
    color: #6b7280;
    line-height: 1.3;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .toggle-container-mobile {
    flex-shrink: 0;
    margin-left: 12px;
  }

  .toggle-group-mobile {
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
  }

  .toggle-item-mobile {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    justify-content: flex-end;
  }

  .toggle-label-mobile {
    font-size: 0.75rem;
    font-weight: 500;
    color: #6b7280;
    min-width: 50px;
  }

  .toggle-switch-mobile {
    position: relative;
    display: inline-block;
    width: 40px;
    height: 24px;
  }

  .toggle-switch-mobile input {
    opacity: 0;
    width: 0;
    height: 0;
  }

  .toggle-slider-mobile {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #e5e7eb;
    transition: 0.4s;
    border-radius: 24px;
  }

  .toggle-slider-mobile:before {
    position: absolute;
    content: "";
    height: 18px;
    width: 18px;
    left: 3px;
    bottom: 3px;
    background-color: white;
    transition: 0.4s;
    border-radius: 50%;
  }

  input:checked + .toggle-slider-mobile {
    background-color: #2563eb;
  }

  input:checked + .toggle-slider-mobile:before {
    transform: translateX(16px);
  }

  .card-content-mobile {
    display: flex;
    flex-direction: column;
    gap: 16px;
  }

  .stats-row-mobile {
    display: flex;
    gap: 24px;
    padding: 12px;
    background-color: #f9fafb;
    border-radius: 8px;
  }

  .stat-item-mobile {
    display: flex;
    flex-direction: column;
    gap: 4px;
    flex: 1;
  }

  .stat-label-mobile {
    font-size: 12px;
    color: #6b7280;
    text-transform: uppercase;
    letter-spacing: 0.025em;
    font-weight: 500;
  }

  .stat-value-mobile {
    font-size: 18px;
    font-weight: 600;
    color: #111827;
  }

  .actions-mobile {
    display: flex;
    justify-content: flex-end;
  }

  .action-btn-mobile {
    padding: 8px 16px;
    font-size: 13px;
    font-weight: 500;
    border-radius: 6px;
    cursor: pointer;
    transition: all 0.2s;
    display: flex;
    align-items: center;
    gap: 6px;
  }

  .edit-btn-mobile {
    background-color: #f3f4f6;
    color: #111827;
    border: none;
  }

  .edit-btn-mobile:hover {
    background-color: #e5e7eb;
  }
}

/* Hide mobile cards on desktop */
@media (min-width: 769px) {
  .mobile-cards {
    display: none;
  }
}
</style>
